/**
 * initial data is matching moscow
 * for when we don't get a new one from backend
 */
import { COMMON_PAGE_LOADED } from './constants';
import { ADD_BASKET_ITEM } from '../basket/constants';
import { TOGGLE_COMPARE_PRODUCT } from '../compare/constants';
import { BREAKPOINT_1004, BREAKPOINT_SET } from './breakpoint/constants';

const initialState = {
  cookiePath: '/shop',
  pageLoaded: false,
  requestVerificationToken: null,
  lastKnownResolution: BREAKPOINT_1004,
  isMobileDevice: false,
  rnd: null, // required to recalculate value of selectors on cookie change
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMMON_PAGE_LOADED:
      return { ...state, pageLoaded: true };
    case ADD_BASKET_ITEM:
    case TOGGLE_COMPARE_PRODUCT:
      return { ...state, rnd: action.rnd };
    /**
     * Should only be called when breakpoint actually changes,
     * all that logic is up to AdaptivityProvider implementation
     */
    case BREAKPOINT_SET: {
      const { value } = action;
      return { ...state, lastKnownResolution: value };
    }
    default:
      return state;
  }
}
